import { evaluate, equal, round, parser } from "mathjs";

// Función que cuenta cuantos igual (=) hay en el string
export const countEqual = (str: string) => {

    const contar = (str.match(/=/g)||[]).length

    if (contar === 1) {
        return { 
            ok: true, 
            title: 'Exito',
            msg: `${str} tiene 1 símbolo igual (=)`
        }
    } else {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: 'La expresión no es una ecuación'
        }
    }
}

export const isEquation = (str : string) => {

    // Transforma la ecuación f(x,y)=g(x,y) en la formula f(x,y)-g(x,y)
    const pasoUno = str.concat(")")
    const formula = pasoUno.replace('=','-(');

    const arreglo = [];
    try {
        for (var i = 1; i < 10+1; i++) {
            arreglo.push(isNaN(evaluate(formula,{X:i/10,Y:i/10})))
        }
    } catch (error) {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: 'La expresión no es una ecuación'
        }
    }  
    
    const long = arreglo.filter(Boolean).length

    if (long === 0) {
        return { 
            ok: true, 
            title: 'Exito',
            msg: `${str} es una ecuación`
        }
    } else {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: 'La expresión no es una ecuación'
        }
    }
}

export const equalEquations = (numberDataBase: string, numberUser: string) => {

    // Transforma la ecuación f(x,y)=g(x,y) en la formula f(x,y)-g(x,y)
    const pasoUno = numberDataBase.concat(")")
    const pasoDos = numberUser.concat(")")
    const formulaUno = pasoUno.replace('=','-(');
    const formulaDos = pasoDos.replace('=','-(');

    // Definir funciones de dos variables
    const parseo = parser()
    parseo.evaluate(`f(X,Y) = ${formulaUno}`)
    parseo.evaluate(`g(X,Y) = ${formulaDos}`)

    // Verificar que f(x,y) o g(x,y) no sean cero
    const arregloCero = [];

    try {
        for (let i = 1; i < 10+1; i++) {
            for (let j = 1; j < 10+1; j++) {
                for (let l = 1; l < 10+1; l++) {
                    for (let m = 1; m < 10+1; m++) {
                        arregloCero.push(equal(round(parseo.evaluate(`f(${i/10},${j/10})*g(${l/10},${m/10})`),10),0))
                    }               
                }                  
            }
        }
    } catch (error) {
        return { 
            ok: false, 
            title: 'Sigue intentando!',
            msg: 'Tu respuesta no coincide con la ecuación solución'
        }
    }

    const longArregloCero = arregloCero.length;
    const longTrueArregloCero = arregloCero.filter(Boolean).length;

    if (longArregloCero === longTrueArregloCero) {
        return { 
            ok: false, 
            title: 'Sigue intentando!',
            msg: 'Tu respuesta no coincide con la ecuación solución'
        }
    }

    // Determinar si las funciones f(x,y) y g(x,y) son una un ponderado de la otra
    const arreglo = [];
    try {
        for (let i = 1; i < 10+1; i++) {
            for (let j = 1; j < 10+1; j++) {
                for (let l = 1; l < 10+1; l++) {
                    for (let m = 1; m < 10+1; m++) {
                        arreglo.push(equal(round(parseo.evaluate(`f(${i/10},${j/10})*g(${l/10},${m/10})-f(${l/10},${m/10})*g(${i/10},${j/10})`),10),0))
                    }               
                }                  
            }
        }
    } catch (error) {
        return { 
            ok: false, 
            title: 'Sigue intentando!',
            msg: 'Tu respuesta no coincide con la ecuación solución'
        }
    }

    const longArreglo = arreglo.length;
    const longTrueArreglo = arreglo.filter(Boolean).length;

    if (longArreglo === longTrueArreglo) {
        return { 
            ok: true, 
            title: '¡Felicitaciones!',
            msg: 'Has encontrado la ecuación solución'
        }
    } else {
        return { 
            ok: false, 
            title: 'Sigue intentando!',
            msg: 'Tu respuesta no coincide con la ecuación solución'
        }
    }

}